import { ContentService } from './../../../_services/content.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-concept-index',
  templateUrl: './admin-concept-index.component.html',
  styleUrls: ['./admin-concept-index.component.css']
})
export class AdminConceptIndexComponent implements OnInit {
  conceptList = []
  constructor(
    private contentService : ContentService
    
  ) { }

  ngOnInit(): void {
    this.contentService.getAdminIndex().subscribe(
      x=>{
        this.conceptList = x
      }
    )
  }

}
